import { SHOW_MANAGER_APPROVAL, HIDE_MANAGER_APPROVAL, SETUP_MANAGER_APPROVAL } from './ActionTypes'

const initialState = {
  showManagerApproval: false,
  managerApprovalOnSuccess: () => {},
  managerApprovalOnFailure: () => {},
  managerApprovalButtonText: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MANAGER_APPROVAL:
      return { ...state, showManagerApproval: true }
    case HIDE_MANAGER_APPROVAL:
      return { ...initialState }
    case SETUP_MANAGER_APPROVAL:
      return {
        ...state,
        managerApprovalOnSuccess: action.payload.onSuccess,
        managerApprovalOnFailure: action.payload.onFailure,
        managerApprovalButtonText: action.payload.buttonText || null,
        showManagerApproval: action.payload.isOpen || false,
      }
    default:
      return state
  }
}

export default reducer
